import { Button } from "react-migration/components/Button";
import { Action, ActionGroup, ActionGroups, Actions } from "./DebugActions";
import { ENVIRONMENT } from "src/js/util/environment";
import { updateActiveLayer } from "src/js/stores/map/actions/updateActiveLayer";
import { BundleId, mapStore } from "src/js/stores/map/store";
import { useSnapshot } from "valtio";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";

export function DevelopmentMenu() {
  const {
    settings: { activeLayer },
  } = useSnapshot(mapStore);
  if (ENVIRONMENT.APP_ENV !== "local") return null;

  return (
    <ActionGroup name={ActionGroups.Development}>
      <Action group={ActionGroups.Development} name={Actions.Sandbox}>
        <Button
          onClick={() => {
            if (activeLayer === BundleId.SANDBOX) {
              hasFeature(Feature.usAccess)
                ? updateActiveLayer(BundleId.US_ALL_NEW)
                : updateActiveLayer(BundleId.UK_ALL_NEW);
            } else {
              updateActiveLayer(BundleId.SANDBOX);
            }
          }}
        >
          {activeLayer === BundleId.SANDBOX ? "Disable" : "Enable"}
        </Button>
      </Action>
    </ActionGroup>
  );
}
